module.exports = __webpack_public_path__ + "assets/img/block-right-0f66b933.png";